.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  font-size: 14px;
  font-weight: 700;
}

.search {
  width: 100%;
  min-height: 52px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 16px;
}

.options {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
}

.option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  min-height: 64px;
  padding: 12px 14px;
  border: 0;
  border-top: 1.5px solid var(--ink);
  background: var(--surface);
  text-align: left;
  cursor: pointer;
}

.option:first-child {
  border-top: 0;
}

.option:hover {
  background: var(--accent-soft);
}

.chosen {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent-soft);
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.title {
  font-size: 16px;
  font-weight: 700;
}

.description {
  font-size: 14px;
  line-height: 1.45;
  color: var(--ink-2);
}

.languages {
  font-size: 13px;
  color: var(--ink-3);
}

.change {
  flex: 0 0 auto;
  min-height: 44px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.empty {
  color: var(--ink-2);
}
